<div class="modal-header">
  <div class="d-flex w-100">
    <h2 class="text-primary modal-title"></h2>
    <h2 class="modal-title text-primary text-center w-100">{{ "CookiesPolicy" | translate }} </h2>
  </div>

</div>
<div class="modal-body m-3">
  <div class="m-auto text-justify  p-3 mb-4">

    <p> {{ "policyCookiesText1" | translate }} </p>

    <p>
      {{ 'policyCookiesText2' | translate }}
      <a href="/#/cookies-policy" target="_blank" rel="noopener">
        {{ 'legal_privacy' | translate }}
      </a>
      {{ 'policyCookiesText3' | translate }}
    </p>

    <p>  {{ "policyCookiesText4" | translate }}   </p>

  </div>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="aceptar()"> {{ "accept" | translate }}
  </button>
  <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="rechazar()"> {{ "btnDenyCookies" |
    translate }} </button>
</div>
